import React, { useState } from 'react'
import {  FaLocationArrow } from 'react-icons/fa'
import { useNavigate, useParams } from 'react-router-dom'

const AdStoreCard = ({ ad }) => {
    // console.log(ad)

    const navigate = useNavigate()
    const { name } = useParams()
    return (
        <div className='ad'>
            <div className="ad-ad-header">
                <img src={ad?.logo?.url} alt="" />
                <h3>{ad?.name}</h3>
            </div>
            <div className="ad-ad-body">
                <div className="ad-ad-text">
                    <p>{ad?.description}</p>
                </div>
                <div className="ad-ad-images">
                    <img src={ad?.banner?.url} alt="" />
                </div>
            </div>
            <div className="store-ad-products">
                <h4>Products</h4>
            {/* some products here */}
            </div>
            <FaLocationArrow />
            <strong>Country: {ad?.address?.country},{ad?.address?.city}</strong>
            <strong>Building: {ad?.address?.building}</strong>
            <strong>Email: {ad?.contacts?.email}</strong>
            <strong>phone: {ad?.contacts?.phone}</strong>

            {/* Promote CTA */}
            <button className="promote-btn" onClick={() => navigate(`/b/manage/${name}/promotions/store/create`, { state: { ad: ad, adType: "store" } })}>
                Promote
            </button>
        </div>
    )
}

export default AdStoreCard